export type VersionComparisonResult = "below_minimum" | "meets_minimum" | "unverified";

interface CompareInstalledVersionInput {
  installedVersion: string | null | undefined;
  minimumVersion: string | null | undefined;
}

/**
 * Compares native marketing versions for the v1 version gate. The mobile app gates launch on it,
 * and the web cutoff checks use it to confirm an enforced minimum covers a required release.
 */
export function compareInstalledVersion({
  installedVersion,
  minimumVersion,
}: CompareInstalledVersionInput): VersionComparisonResult {
  const installedSegments = parseVersionSegments(installedVersion);
  const minimumSegments = parseVersionSegments(minimumVersion);

  if (!installedSegments || !minimumSegments) {
    return "unverified";
  }

  const segmentCount = Math.max(installedSegments.length, minimumSegments.length);
  for (let index = 0; index < segmentCount; index += 1) {
    const installedSegment = installedSegments[index] ?? 0;
    const minimumSegment = minimumSegments[index] ?? 0;

    if (installedSegment < minimumSegment) {
      return "below_minimum";
    }

    if (installedSegment > minimumSegment) {
      return "meets_minimum";
    }
  }

  return "meets_minimum";
}

function parseVersionSegments(version: string | null | undefined): number[] | undefined {
  const normalizedVersion = version?.trim();
  if (!normalizedVersion || !/^\d+(?:\.\d+)*$/.test(normalizedVersion)) {
    return undefined;
  }

  return normalizedVersion.split(".").map((segment) => Number.parseInt(segment, 10));
}
